/**
 * FIX-258: work orders are soft-deleted only via the `soft_delete_work_order`
 * RPC. The permission rule lives in SQL (`work_order_delete_check`); this file
 * only maps its result codes to translation keys and builds the reason text.
 */
export const DELETE_REFUSAL_CODES = [
  "completed",
  "has_parts",
  "has_passport",
  "not_allowed",
  "not_found",
  "already_deleted",
  "reason_required",
] as const;
export type DeleteRefusalCode = (typeof DELETE_REFUSAL_CODES)[number];
export type DeleteCheckResult = "ok" | DeleteRefusalCode;

export const DELETE_REASONS = ["wrong_appliance", "duplicate", "test_data", "other"] as const;
export type DeleteReason = (typeof DELETE_REASONS)[number];

/** Extract a refusal code from an RPC error message; unknown errors → "unknown". */
export function refusalCodeFromError(message: string | null | undefined): DeleteRefusalCode | "unknown" {
  const m = (message ?? "").trim();
  return (DELETE_REFUSAL_CODES as readonly string[]).includes(m) ? (m as DeleteRefusalCode) : "unknown";
}

/** Reason text stored on the work order; null when incomplete. */
export function buildDeleteReason(reason: DeleteReason | null, otherText: string): string | null {
  if (!reason) return null;
  if (reason === "other") {
    const t = otherText.trim();
    return t ? `other: ${t}` : null;
  }
  return reason;
}
